import { css, keyframes, styled } from "styled-components";

import { Image, RedCircleErrorIcon } from "common/components";

const keyframesFullView = keyframes`
  100% {
    width: 100%;
  }
`;

const keyframesShimmer = keyframes`
  0% {
    background-position: -80vw 0;
  }
  100% {
    background-position: 80vw 0;
  }
`;

const shimmerAnimation = css`
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.placeholderGradientPrimary} 4%,
    ${({ theme }) => theme.colors.placeholderGradientSecondary} 25%,
    ${({ theme }) => theme.colors.placeholderGradientPrimary} 36%
  );
  background-size: 80vw 100%;
  animation: ${keyframesShimmer} 3s infinite linear;
`;

export const StyledScrapedKnowledgeContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  margin-bottom: 30px;
  ${keyframesFullView}
`;

export const StyledURLPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 20px 15px 20px 19.3px;
  border-radius: 5px;
  row-gap: 15px;
`;

export const StyledURLPhotoPlaceholder = styled.div`
  height: 64px;
  width: 64px;
  border-radius: 5px;
  ${shimmerAnimation}
`;

export const StyledURLTitlePlaceholder = styled.div`
  height: 33px;
  width: 100%;
  border-radius: 5px;
  ${shimmerAnimation}
`;

export const StyledURLDescriptionPlaceholder = styled.div`
  height: 22px;
  width: 100%;
  border-radius: 5px;
  ${shimmerAnimation}
`;

export const StyledURLHalfDescriptionPlaceholder = styled.div`
  height: 22px;
  width: 50%;
  border-radius: 5px;
  ${shimmerAnimation}
`;

export const StyledHeroImagePlaceholder = styled.div`
  width: 100%;
  height: 230px;
  border-radius: 4px;
  margin-right: 1rem;
  ${shimmerAnimation}
`;

export const StyledInsightAreaChipPlaceholder = styled.div`
  display: inline-block;
  width: 80px;
  height: 40px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.background};
  font-size: 16px;
  margin-right: 5px;
  margin-bottom: 8px;
  ${shimmerAnimation}
`;

export const StyledPublisherImage = styled(Image)`
  width: 64px;
  min-width: 64px;
  height: 64px;
  border-radius: 4px;
  margin-right: 1rem;
  object-fit: contain;
`;

export const StyledHeroImage = styled(Image)`
  width: 100%;
  height: 230px;
  border-radius: 4px;
  margin-right: 1rem;
`;

export const StyledKnowledgeInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

export const StyledURLPreviewTitle = styled.h1`
  font-size: 24px;
  line-height: 1.33;
  color: ${({ theme }) => theme.colors.wefLogoText};
  margin: 0px;
`;

export const StyledKnowledgeInfoHeading = styled.h1`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textBright};
`;

export const StyledKnowledgeInfoText = styled.p`
  font-size: 16px;
  line-height: 1.38;
  margin: 0px;
`;

export const StyledKnowledgeInsightAreaContainer = styled.div`
  display: inline;
`;

export const StyledInsightAreaChip = styled.div`
  display: inline-block;
  width: fit-content;
  max-width: 600px;
  max-height: 40px;
  padding: 10px 20px;
  border-radius: 20px;
  border: solid 1px #757575;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.wefLogoText};
  font-size: 16px;
  margin-right: 5px;
  margin-bottom: 8px;
`;

export const StyledErrorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
`;

export const StyledErrorMessage = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.wefLogoText};
`;

export const StyledRedCircleErrorIcon = styled(RedCircleErrorIcon)`
  width: 60px;
  align-self: flex-start;
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.fillPrimary};
`;
